export default {
  ADMIN: 'ADMIN',
};
